import { profilePersonalInfoPage } from 'platform/forms-system/src/js/patterns/prefill';

const claimantPersonalInformation = profilePersonalInfoPage({
  key: 'personalInformation',
  title: 'Personal information',
  path: 'your-personal-information',
  personalInfoConfig: {
    name: { show: true, required: true },
    ssn: { show: true, required: true },
    dateOfBirth: { show: true, required: true },
    vaFileNumber: { show: false, required: false },
    sex: { show: false, required: false },
  },
  dataAdapter: {
    ssnPath: 'yourSocialSecurityNumber',
  },
  // TODO(phase 2): remove depends after survivors_benefits_updated_prefill is 100% in prod
  depends: formData => formData?.survivorsBenefitsUpdatedPrefill === true,
});

export default claimantPersonalInformation;
